
import ManageMotif from '@/views/consultations/en-cours/motif-histoire/manage-motif'

export default {
    name: 'motif-histoire',
    components: {
        ManageMotif
    },
    props: {
        consultation: Object,
        section_name: String,
        evolution_id: Number,
        evolution_toggler: Number,
        current_consultation_evolution: Number,
        is_start: Number,
        user_info: Object
    },
    data() {
        return {
            loading: false,
            motif_histoire: {
                motif: null,
                histoire: null
            },

            filtered_motif: [],
            value: '',
            motifs: [
                {
                    id: 0,
                    motif: ''
                }
            ],
            motif_selected: [],

            save_loading: false,
            btn_disable: false,
            btn_disable_h: false,

            data_to_be_deleted: {},
            del_loading: false,
            is_confirm: false,
            
            tmp_motifs: [],   // Motif tempon à l'ajout

            // -----------------
            motif_is_loading: true,
            motif_is_empty: false,
            group_id: 0,
            info_user: {}
        }
    },

    watch: {
        evolution_toggler() {
            this.$store.commit("SET_CONSULTATION_MOTIFS", [])
            this.refreshListeDesMotifs()

            this.refreshConsultationMotif()
            this.userInfoSetter()
        }
    },

    computed: {
        liste_motifs() {
            return this.$store.getters["liste_motifs"];
        },

        consultation_motifs() {
            return this.$store.getters["consultation_motifs"];
        },

        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        evolution_id_initiale() {
            return this.$store.getters['evolution_id_initiale']
        }
    },

    mounted() {
        
    },

    methods: {
        userInfoSetter() {
            this.info_user = {
                nom_medecin: this.user_info.user,
                titre: this.user_info.titre
            }
        },

        refreshListeDesMotifs() {
            this.$store.dispatch("getListeMotifs")
        },

        refreshConsultationMotif() {
            this.$store.commit("SET_CONSULTATION_MOTIFS", [])
            this.motif_is_loading = true
           
            let data = {
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id_initiale,
                est_en_cours: true 
            }

            this.$store.dispatch("getConsultationMotifs", data).then(() => {
                if (this.consultation_motifs.length == 0) {
                    this.motif_is_empty = true
                } else {
                    this.motif_is_empty = false
                }

                this.motif_is_loading = false
            })
        },

        filterMotifs() {
            this.filtered_motif = [];
            if (this.value.length > 2) {
                this.liste_motifs.forEach(
                    element => {
                        if (element.libelle.toLowerCase().includes(this.value.toLowerCase())) {
                            this.filtered_motif.push(element)
                        }
                    }
                )
            }
        },

        addExistingMotif(data) {
            let j = 0
            let len = this.tmp_motifs.length

            let tmp_motif = {}
            this.liste_motifs.forEach(function (el) {
                if (data.libelle == el.libelle) {
                    tmp_motif = {
                        id: el.id,
                        motif: el.libelle
                    }
                }
            });

            // Verifier si motif déjà choisi
            if (len > 0) {
                for (let i = 0; i < this.tmp_motifs.length; i++) {
                    if (data.libelle == this.tmp_motifs[i].motif) {
                        j++;
                    }
                }
            }
            if (j == 0) {
                this.tmp_motifs.push(tmp_motif);

                this.value = ''

            }
            this.filtered_motif = []
        },

        /**
         * Ajoute un nouveau motif
         * @param {} index 
         */
        addNewMotif() {
            let j = 0
            let len = this.tmp_motifs.length

            let tmp_motif = {
                id: 0,
                motif: this.value
            }

            // Verifier si motif déjà choisi
            if (len > 0) {
                for (let i = 0; i < this.tmp_motifs.length; i++) {
                    if (this.value == this.tmp_motifs[i].motif) {
                        j++;
                    }
                }
            }
            if (j == 0) {
                this.tmp_motifs.push(tmp_motif);

                this.value = ''
                this.filtered_motif = []
            }
        },

        saveMotifHistoire: function () {
            this.loading = true
            this.btn_disable_h = true

            this.$store.dispatch("saveMotifHistoire", { id: this.consultation.id, data: this.motif_histoire }).then(() => {
                this.motifHistoireSuccessMessage()
                this.loading = false
                this.btn_disable_h = false

                this.refreshConsultationMotif()
            })
        },

        motifHistoireSuccessMessage: function () {
            this.$toasted.show('Les informations ont été enregistrées avec succès', {
                duration: 3000,
                action: [
                    {
                        text: 'X',
                        onClick: (e, toastObject) => {
                            toastObject.goAway(0);
                        }
                    }
                ],
                theme: 'toasted-primary',
                type: 'success',
                position: 'top-center'

            })
        },

        addToListMotif(group_motif_id) {
            this.group_id = group_motif_id
        },

        remove(data, group_id) {
            this.data_to_be_deleted = {
                id: data.motif_id,
                libelle: data.motif,
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                user_id: this.user_info.id,
                group_id: group_id
            }
        },

        removeGroupMotif(group_motif) {
            this.data_to_be_deleted = {
                libelle: group_motif.reference,
                consultation_id: this.consultation.id,
                evolution_id: this.evolution_id,
                user_id: this.user_info.id,
                group_id: group_motif.motif_group_id
            }
        }
    }
}